<div class="app">
  <app-header [showMenu]="showMenu"></app-header>
  <main (click)="showMenu = false">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
